import { Link } from "react-router-dom";

export default function ComplianceFooter() {
  return (
    <footer className="border-t border-slate-200 bg-white/60 backdrop-blur-sm" data-testid="compliance-footer">
      <div className="max-w-5xl mx-auto px-6 py-6 text-[11px] text-slate-500 leading-relaxed">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div className="text-slate-600">
            <a
              href="https://besafebroker.it"
              target="_blank"
              rel="noopener noreferrer"
              className="font-semibold text-slate-700 hover:text-[#0F7B85]"
              data-testid="footer-site-link"
            >
              BeSafe Broker S.r.l. ↗
            </a> · P.IVA <span className="font-mono">07093890825</span> · RUI <strong>B000725320</strong> · Vigilanza IVASS
          </div>
          <nav className="flex items-center gap-4 text-slate-500 flex-wrap">
            <Link to="/privacy" className="hover:text-[#0F7B85] hover:underline" data-testid="footer-privacy-link">Privacy</Link>
            <span className="text-slate-300">·</span>
            <a
              href="https://besafebroker.it/cookie-policy-ue/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#0F7B85] hover:underline"
              data-testid="footer-cookie-link"
            >Cookie ↗</a>
            <span className="text-slate-300">·</span>
            <a
              href="https://besafebroker.it/contatti/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#0F7B85] hover:underline"
              data-testid="footer-contacts-link"
            >Contatti ↗</a>
            <span className="text-slate-300">·</span>
            <a
              href={`${process.env.REACT_APP_BACKEND_URL}/api/regolamento.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#0F7B85] hover:underline"
              data-testid="footer-regolamento-link"
            >Regolamento PDF</a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
